import script from "./overview.vue?vue&type=script&setup=true&lang=js"
export * from "./overview.vue?vue&type=script&setup=true&lang=js"

import "./overview.vue?vue&type=style&index=0&id=511d2094&scoped=true&lang=scss"

import exportComponent from "D:\\liu\\jmzc\\vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-511d2094"]])

export default __exports__